// extracted by mini-css-extract-plugin
export default {"root":"_33FX3UyS9mzaiI7RhGMnB4","addFavIcon":"_3vIJKbKH_jLBUQiMo-aQfc","removeFavIcon":"t38kHPCDjFtWalFm5gmn0"};